import { bool, func, string, object } from 'prop-types'
import { Size } from '@opallabs/gem'
import { kuiperClassNames } from '@opallabs/kuiper'
import { Icon } from '@opallabs/lapidary'
import { newDateObject } from '../../helpers/dateHelpers'
import { isInWorkflowPopover } from '../../helpers/matchers'
import { dateDisplay, glyphName } from './helpers'
import PhaseNameField from './PhaseNameField'

import './styles.scss'

const Header = ({
  disabled = false,
  dueDate,
  hideDate,
  isComplete = false,
  isExpanded,
  isFinalApproval = false,
  onClickHeader,
  phaseName,
  phaseType,
  theme,
  updatePhase,
  workflowLocation,
}) => {
  const shouldDisable =
    disabled || isComplete || isInWorkflowPopover(workflowLocation)
  const unscheduledDateText = isInWorkflowPopover(workflowLocation)
    ? 'No Date'
    : 'Schedule'

  /* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
  return (
    <div
      className={kuiperClassNames('phase-header', `theme-${theme}`, {
        complete: isComplete,
        disabled: shouldDisable,
        expanded: isExpanded,
        finalApproval: isFinalApproval,
      })}
      onClick={onClickHeader}
    >
      <Icon
        ariaHidden
        glyph={glyphName(phaseType)}
        height={Size.Icon}
        useHypernova={!glyphName(phaseType).includes('gem-')}
        width={Size.Icon}
      />

      <PhaseNameField
        disabled={shouldDisable}
        name={phaseName}
        onChangeName={updatePhase}
        phaseType={phaseType}
      />

      {dateDisplay({
        disabled: shouldDisable,
        dueDate: newDateObject(dueDate),
        hideDate,
        isComplete,
        onChangeDate: updatePhase,
        unscheduledDateText,
      })}
    </div>
  )
  /* eslint-enable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
}

Header.propTypes = {
  disabled: bool,
  dueDate: object.isRequired,
  hideDate: bool.isRequired,
  isComplete: bool,
  isExpanded: bool.isRequired,
  isFinalApproval: bool,
  onClickHeader: func.isRequired,
  phaseName: string.isRequired,
  phaseType: string.isRequired,
  theme: string,
  updatePhase: func.isRequired,
  workflowLocation: string,
}

export default Header
